module.exports = __webpack_public_path__ + "img/services-o.ede5367a.svg";